import * as React from 'react'
import styled from 'styled-components'
import I18n from '../../../../core/i18n'
import { IJsonResponse } from '../../../../core/JsonApiSerializer'
import { adminService } from '../../../../core/services'
import * as interfaces from '../../../../static/interfaces'
import * as Hooks from '../../../../utils/hooks'
import { Button } from '../../../atoms'
import AdminLayoutIndex from '../_layouts'
import { Container, Draggable } from 'react-smooth-dnd'
import arrayMove from 'array-move'
import * as constants from '../../../../static/constants'
import SvgIcon from 'components/atoms/SvgIcon'

declare var window: interfaces.IWindow

interface IProps {
  pickups: {
    pickups: IJsonResponse
  }
  display_languages: IJsonResponse
}

const AdminPickupIndex: React.FC<IProps> = props => {
  Hooks.SetDocumentTitle('Admin Pickups')
  const { data, pagination } = adminService.getDataFromJson(props.pickups.pickups)
  const { data: display_languages } = adminService.getDataFromJson(props.display_languages)
  const [pickups, setPickups] = React.useState(data)

  const handleDelete = React.useCallback(
    async id => {
      const { flush } = await adminService.deletePickup(id)
      // TODO 成功レスポンスと揃えたい
      window.flashMessages.addMessage({
        text: flush.message,
        type: flush.type,
      })
      setPickups(pickups.filter(pickup => pickup.id !== id))
    },
    [pickups]
  )
  const onDrop = ({ removedIndex, addedIndex }) => {
    setPickups(old => arrayMove(old, removedIndex, addedIndex))
  }

  const onSubmit = () => {
    updatePickupsOrder()
  }

  const updatePickupsOrder = React.useCallback(async () => {
    const pickups_ids = pickups.map(item => {
      return item.id
    })
    const { updatedPickups, flush } = await adminService.updatePickups(pickups_ids)
    window.flashMessages.addMessage({ text: flush.message, type: flush.type })
    location.href = `/admin/pickups?display_language_id=${updatedPickups.display_language_id}`
  }, [pickups])

  const handleClickDelete = id => {
    if (window.confirm(I18n.t('generic.delete_confirmation'))) {
      handleDelete(id)
    }
  }

  return (
    <AdminLayoutIndex
      model="pickup"
      title={
        <Heading>
          <span>{I18n.t('generic.best_sellers')}</span>
          <Button small={true}>
            <a
              href={`/admin/pickups/new?display_language_id=${
                display_languages.find(display_language => display_language.current)?.id
              }`}
            >
              {I18n.t('generic.create_new')}
            </a>
          </Button>
        </Heading>
      }
      main={
        <>
          {display_languages.map(display_language => (
            <Button small={true} primary={display_language.current} key={display_language.id}>
              <a href={`/admin/pickups?display_language_id=${display_language.id}`}>
                {display_language.name_i18n}
              </a>
            </Button>
          ))}
          <DraggableTable>
            <div className="Table">
              <div>
                <div className="Table_Row">
                  <div className="Table_Header">{I18n.t('generic.post_id')}</div>
                  <div className="Table_Header label">{I18n.t('generic.name')}</div>
                  <div className="Table_Header label">{I18n.t('post.display_language')}</div>
                  <div className="Table_Header label" />
                  <div className="Table_Header handle" />
                </div>
              </div>
              <div>
                <Container onDrop={onDrop}>
                  {pickups.map((pickup, index) => {
                    return (
                      <Draggable key={`pickup-${index}`}>
                        <div className="Table_Row">
                          <div className="Table_Data">
                            <a href={`/posts/${pickup.post_id}`} target="blank">
                              {pickup.post_id}
                            </a>
                          </div>
                          <div className="Table_Data label">
                            <a href={`/posts/${pickup.post_id}`} target="blank">
                              {pickup.post_name}
                            </a>
                          </div>
                          <div className="Table_Data label">
                            {pickup.display_language.name_i18n}
                          </div>
                          <div className="Table_Data">
                            <Button
                              small={true}
                              handleClick={() => {
                                handleClickDelete(pickup.id)
                              }}
                            >
                              {I18n.t('generic.delete')}
                            </Button>
                          </div>
                          <div className="Table_Data handle">
                            <SvgIcon
                              name="drag_handle"
                              className="icon"
                              ariaHidden={true}
                              role="presentation"
                            />
                          </div>
                        </div>
                      </Draggable>
                    )
                  })}
                </Container>
              </div>
            </div>
            <Button handleClick={onSubmit}>{I18n.t('generic.update_order')}</Button>
          </DraggableTable>
        </>
      }
    />
  )
}

const Heading = styled.div`
  .Button {
    margin-left: 12px;
  }
`
const DraggableTable = styled.div`
  .Table {
    display: table;
    margin-bottom: 20px;
    .Table_Header,
    .Table_Data {
      display: table-cell;
      max-width: 240px;
      width: 120px;
      height: 40px;
      padding: 4px 8px;
      vertical-align: middle;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      border-bottom: solid 1px ${constants.COLORS.divider};
      &.handle {
        cursor: grab;
        &:active {
          cursor: grabbing;
        }
      }
      > a {
        color: ${constants.COLORS.primary};
      }
      &.label {
        width: 240px;
      }
      &.handle {
        width: 40px;
        text-align: center;
      }
    }
  }
`

export default AdminPickupIndex
